/* card-unit-price.js
   Atualiza .price__current do card de produto conforme:
   - variant selecionada (chip de tamanho)
   - One-time vs Subscribe (radios .purchase_option)
   - Plano de assinatura escolhido (select.selling_plan_product)

   JSON consumido: <script id="unitPrices-X" data-unit-prices> com
     { "uom": "lb", "variants": { "VID": { "u": unit_count, "p": price_ot_cents } } }

   Para Subscribe: lê preço do plano em <script id="loopPlans-X" data-loop-plans>
   já renderizado pelo product-card.liquid para o widget Loop mini.

   Cálculo: perUnitCents = currentPrice / unit_count
   (currentPrice é OT, Sub plan, ou OT como fallback)

   Versão 15/mai/2026: refator de v1 (que só tinha per_unit_ot fixo).
*/
(function () {
  if (window.__CARD_UNIT_PRICE_INITED__) return;
  window.__CARD_UNIT_PRICE_INITED__ = true;

  var cfg = window.LoopMiniConfig || {};
  var moneyFormat = cfg.moneyFormat || '${{amount}}';
  var currency = cfg.currency || 'USD';

  function fmt(cents) {
    try {
      if (window.Shopify && typeof Shopify.formatMoney === 'function') {
        return Shopify.formatMoney(Math.round(cents), moneyFormat);
      }
    } catch (e) {}
    return (cents / 100).toLocaleString(undefined, { style: 'currency', currency: currency });
  }

  function initCard(card) {
    if (card.dataset.cardUnitPriceInited) return;

    var unitDataEl = card.querySelector('script[data-unit-prices]');
    if (!unitDataEl) return;

    var unitData;
    try {
      unitData = JSON.parse(unitDataEl.textContent);
    } catch (e) {
      return;
    }
    if (!unitData || !unitData.variants) return;

    var priceCurrentEls = card.querySelectorAll('.price--top .price__current.theme-money, .price--bottom .price__current.theme-money');
    if (!priceCurrentEls.length) return;

    card.dataset.cardUnitPriceInited = '1';

    var form = card.querySelector('form.js-product-form-main') || card.querySelector('form.js-product-form');

    // loopPlans JSON tem preços de planos (se houver subscription). Pode ser null.
    var loopPlansEl = card.querySelector('script[data-loop-plans]');
    var loopData = null;
    if (loopPlansEl) {
      try {
        loopData = JSON.parse(loopPlansEl.textContent);
      } catch (e) {
        loopData = null;
      }
    }

    function getCurrentVariantId() {
      if (form) {
        var idInput = form.querySelector('input[name="id"]');
        if (idInput && idInput.value) return idInput.value;
      }
      var checked = card.querySelector('.option-selector__btns .opt-btn:checked');
      if (checked) {
        var label = checked.closest('label');
        var hidden = label && label.querySelector('.variant_id_by_checked');
        if (hidden && hidden.value) return hidden.value;
      }
      return null;
    }

    // Retorna o preço (cents) que deve ser usado pelo per-unit:
    // - Sub selecionado + plano disponível → preço do plano
    // - Caso contrário → preço OT (v.price)
    function getCurrentPriceCents(vid) {
      var info = unitData.variants[vid];
      if (!info) return null;

      var subRadio = card.querySelector('.wrap-subscription input[type="radio"][value="sub"]');
      var isSub = subRadio && subRadio.checked && !subRadio.disabled;

      if (!isSub || !loopData || !loopData.variants || !loopData.variants[vid]) {
        return info.p; // OT
      }

      var v = loopData.variants[vid];
      if (!v.plans || !v.plans.length) return info.p;

      // Tenta ler plano selecionado no <select>
      var sel = card.querySelector('select.selling_plan_product');
      if (sel && sel.value) {
        for (var i = 0; i < v.plans.length; i++) {
          if (String(v.plans[i].id) === String(sel.value)) {
            return (v.plans[i].price != null) ? v.plans[i].price : info.p;
          }
        }
      }
      // Fallback para o primeiro plano
      return (v.plans[0].price != null) ? v.plans[0].price : info.p;
    }

    function refresh() {
      var vid = getCurrentVariantId();
      if (!vid) return;
      var info = unitData.variants[vid];
      if (!info || !info.u || info.u <= 0) return;

      var priceCents = getCurrentPriceCents(vid);
      if (priceCents == null) return;

      var perUnit = priceCents / info.u;
      var formatted = fmt(perUnit);
      priceCurrentEls.forEach(function (el) {
        el.textContent = formatted;
      });
    }

    card.addEventListener('change', function (e) {
      var t = e.target;
      if (!t) return;

      // Chip de variante
      var isOptionChip = (t.classList && t.classList.contains('js-option')) ||
                         (t.closest && t.closest('.option-selector__btns'));

      // Radio OT/Sub
      var isPurchaseRadio = t.matches && (
        t.matches('.wrap-subscription input[type="radio"][value="ot"]') ||
        t.matches('.wrap-subscription input[type="radio"][value="sub"]')
      );

      // Select de plano de assinatura
      var isPlanSelect = t.matches && t.matches('select.selling_plan_product');

      if (isOptionChip || isPurchaseRadio || isPlanSelect) {
        // setTimeout 0 para variant-picker.js atualizar input[name=id] primeiro
        setTimeout(refresh, 0);
      }
    });

    // Estado inicial
    refresh();
  }

  function initAll() {
    document.querySelectorAll('product-card').forEach(initCard);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('cart:updated', initAll);
})();
